import { onlyNumberInput, onlyNumberWithFlotingInput, parseOnlyNumericValue, safeToString, sliceText } from "../../../utils/common";


const onlyNumberWithFloatingInput = (value) => {

  value = value.replace(/[^0-9.]/g, '');

  const parts = value.split('.');
  if (parts.length > 2) {
      value = parts[0] + '.' + parts.slice(1).join('');
  }

  if (value.includes('.')) {
      value = value.match(/^\d{0,3}(\.\d{0,2})?/)[0];
  } else {
  
      value = value.substring(0, 4);
  }

  return value;
};


export const SALARY_KNOWN_BASIC="basic_salary";
export const SALARY_KNOWN_CTC="ctc_salary";
export const SALARY_TYPE_SALARY="salary";
export const SALARY_TYPE_WAGES="wages";

export const PAY_AND_BENEFITS_INITIAL_STATE={
  "salary_type": SALARY_TYPE_SALARY,
    "salary_known":SALARY_KNOWN_CTC,
    "basic_salary": "",
    "ctc_salary": "",
    "gross_salary":"",
    "basic_percentage": 60,
    "wages_type": "",
    "wages_rate": "",
    "wages_payment_mode": "",
    "wages_day": "",
    "payment_mode": "account_transfer",
    "ot_rate": null,
    "labour_welfare_fund": "No",
    // employee_weekly_holiday:  {
    //   "sunday": false,
    //   "monday": false,
    //   "tuesday": false,
    //   "wednesday": false,
    //   "thursday": false,
    //   "friday": false,
    //   "saturday": false,
    //   "is_payable": false
    // }
}
 
export const HOLIDAY_LIST=[{id:"sunday",label:"Sunday"},{id:"monday",label:"Monday"},{id:"tuesday",label:"Tuesday"},{id:"wednesday",label:"Wednesday"},{id:"thursday",label:"Thursday"},{id:"friday",label:"Friday"},{id:"saturday",label:"Saturday"}]



export const PAY_AND_BENEFITS_CONST = {
  salary_type: {
      name: "salary_type",
      label: "Salary Type",
      inputType: "selectField",
      component: "SelectField",
      fullWidth: true,
      placeholder: "Select Here...",
      options: [
        { id: SALARY_TYPE_SALARY, name: "Salary" },
        { id: SALARY_TYPE_WAGES, name: "Wages" },
      ],
     
      required:true
    },
    salary_known: {
      name: "salary_known",
      label: "Salary Known",
      inputType: "selectField",
      component: "SelectField",
      fullWidth: true,
      placeholder: "Select Here...",
      options: [
        { id: SALARY_KNOWN_BASIC, name: "Basic" },
        { id:SALARY_KNOWN_CTC, name: "CTC" },
      ],
      required:true

    },
    basic_percentage: {
      name: "basic_percentage",
      label: "Basic Percentage",
      inputType: "inputField",
      component: "InputField",
      fullWidth: true,
      placeholder: "Type Here...",
      prefix: "%",
      required:true,

      customOptions: {
           formatValueFn: (value) => sliceText(onlyNumberInput(value), 3)     
           
         },
        
    },
    basic_salary: {
      name: "basic_salary",
      label: "Basic Salary",
      inputType: "inputField",
      component: "InputField",
      fullWidth: true,
      placeholder: "Type Here...",
      required:true,
      suffix: "₹",
      customOptions: {
        formatValueFn: (value) => sliceText(onlyNumberInput(value), 8)      
        
      },
    },
    gross_salary: {
      name: "gross_salary",
      label: "Gross Salary",
      inputType: "inputField",
      component: "InputField",
      fullWidth: true,
    disabled:true,
      placeholder: "Type Here...",
      required:true,
      suffix: "₹",
      valueSinc:true,
      customOptions: {
        formatValueFn: (value) => sliceText(onlyNumberInput(value), 8)     
        
      },
    },
    ctc_salary: {
      name: "ctc_salary",
      label: "CTC Salary",
      inputType: "inputField",
      component: "InputField",
      fullWidth: true,
      required:true,
    
      placeholder: "Type Here...",
      suffix: "₹",
      customOptions: {
        formatValueFn: (value) => sliceText(onlyNumberInput(value), 8)     
        
      },
    },
    payment_mode: {
      name: "payment_mode",
      label: "Payment Mode",
      inputType: "selectField",
      component: "SelectField",
      required:true,
      fullWidth: true,
      placeholder: "Select Here...",
      options: [
        { id: "account_transfer", name: "Account Transfer" },
        { id: "cheque", name: "Cheque" },
        { id: "cash", name: "Cash" },
      ],
    },
    ot_rate: {
      name: "ot_rate",
      label: "OT Rate",
      inputType: "inputField",
      component: "InputField",
      fullWidth: true,
    
      placeholder: "Type Here...",
      suffix: "₹",
      customOptions: {
        formatValueFn: (value) => sliceText(onlyNumberWithFlotingInput(value), 8)     
        
      },
    },
    labour_welfare_fund: {
      name: "labour_welfare_fund",
      label: "Labour Welfare Fund",
      inputType: "selectField",
      component: "SelectField",
      required:true,
      fullWidth: true,
      placeholder: "Select Here...",
      options: [
        { id: "Yes", name: "Yes" },
        { id: "No", name: "No" },
      ],
    },
    wages_type: {
      name: "wages_type",
      label: "Wage Type",
      inputType: "selectField",
      component: "SelectField",
      fullWidth: true,
      required:true,
      placeholder: "Select Here...",
      options: [
        { id: "days", name: "Days",  },
        { id: "hours", name: "Hours", disabled: true  },
        { id: "pieces", name: "Per/Pieces",disabled: true  },
      ],
    }, 
    wages_rate: {
      name: "wages_rate",
      label: "Wage Rate",
      inputType: "inputField",
      component: "InputField",
      fullWidth: true,
      required:true,
      suffix: "₹",
      placeholder: "Type Here...",
      customOptions: {
        formatValueFn: (value) => {
            return sliceText(onlyNumberWithFloatingInput(value), 6); // Allowing up to 6 characters including the decimal
        }
    }
    },
    wages_payment_mode: {
      name: "wages_payment_mode",
      label: "Payment Schedule",
      inputType: "selectField",
      component: "SelectField",
      fullWidth: true,
      placeholder: "Select Here...",
      options: [
        { id: "weekly", name: "Weekly",disabled: true  },
        { id: "fortnight_pay", name: "Fortnight pay",disabled: true  },
        { id: "monthly", name: "Monthly" },
      ],
      required:true,

    },
    wages_day: {
      name: "wages_day",
      label: "Wage Days",
      inputType: "inputField",
      component: "InputField",
      fullWidth: true,
      required:true,
      placeholder: "Type Here...",
      type: "number",
      customOptions: {
        formatValueFn: (value) => {
            const numericValue = parseOnlyNumericValue(safeToString(value));
            const slicedValue = sliceText(numericValue, 2); 
            return Math.min(parseInt(slicedValue, 10), 28).toString(); 
        }
    }
      
    },
  };
  

  export const PAY_AND_BENEFITS_API = {
    PAY_AND_BENEFITS_CREATE: { url: "/employee/employee-benefit/", method: "POST" },
    PAY_AND_BENEFITS_UPDATE: { url: "/employee/employee-benefit/", method: "PUT" },
    PAY_AND_BENEFITS_DELETE: { url: "/employee/employee-benefit", method: "DELETE" },
    PAY_AND_BENEFITS_LIST: { url: "/employee/employee-benefit", method: "GET" },
 
  };